import { render } from "./CreateMerchant.vue?vue&type=template&id=5c434b92&scoped=true"
import script from "./CreateMerchant.vue?vue&type=script&lang=js"
export * from "./CreateMerchant.vue?vue&type=script&lang=js"

import "./CreateMerchant.vue?vue&type=style&index=0&id=5c434b92&scoped=true&lang=css"

import exportComponent from "F:\\ssd_backup\\OpenServer\\domains\\paygate.admin-panel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c434b92"]])

export default __exports__